// Tracks whether the initial SSR markup has finished hydrating on the client.
//
// During SSR and during the very first client render (hydration), components
// must render identically to the server output. After the app has mounted, any
// further navigation is a pure client-side (SPA) transition with no server
// markup to match — at that point components are free to defer work (e.g. lazy
// below-the-fold queries) without risking a hydration mismatch.
let hydrated = false;

export const isHydrated = (): boolean => hydrated;

export const markHydrated = (): void => {
  hydrated = true;
};
